import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import { fetchDiasEntrega, loadMantenimiento,fetchFamilia, fetchSucursales } from '../../actions';

import PageHeader from '../../components/PageHeader';
import Alert from '../../components/Alert';
import Paginacion from '../../components/Paginacion';
import Filtros from './Filtros';
import TablaMantenimiento from './TablaMantenimiento';
import Formulario from './Formulario';
import toggleDiv from '../../utils/toggleDiv';
import { createDiasTraslado, editDiasTraslado } from '../../utils/mantenimientoEntrega';

class MantDiasTraslado extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertErrorOpen: false,
      alertSuccessOpen: false,
      // paginacion
      pagina: 1,
      totalRegistros: 0,
      cantidad: 0,
      // filters
      sucursalEntrega: '',
      sucursalDespacho: '',
      cantidadDias: '',
      // modal
      modalOpen: '',
      sucDespacho: '',
      sucEntrega: '',
      canDias: '',
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      modalTitle: 'Crear registro',
      familia: '',

    };
  }

  componentDidMount() {
    document.addEventListener('click', toggleDiv, true);
    this.props.fetchSucursales();
    this.props.fetchDiasEntrega()
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.planificacionDiasEntrega.length }));
        this.props.fetchFamilia();

  }

  componentWillUnmount() {
    document.removeEventListener('click', toggleDiv, true);
  }

  onChangeGroup = (e, group) => {
    const array = this.state[group];
    if (array.indexOf(e.target.value)>=0) {
      this.setState({ [group]: array.filter(item => item !== e.target.value) });
    } else {
      this.setState({ [group]: [...array, e.target.value] });
    }
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value });
  onCheck = e => this.setState({ [e.target.name]: e.target.checked });

  onChangeAndFilter = (e) => {
    this.setState(
      { [e.target.name]: e.target.value },
      () => {
        const { sucursalDespacho, sucursalEntrega, cantidadDias } = this.state;
        this.props.loadMantenimiento();
        this.props.fetchDiasEntrega(sucursalDespacho, sucursalEntrega, cantidadDias)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.planificacionDiasEntrega.length,
            pagina: 1 }));
      }
    );
  }

  createRegistro = () => {
    createDiasTraslado(this.state)
      .then((response) => {
        const { sucursalDespacho, sucursalEntrega, cantidadDias } = this.state;
        if (response.data.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');
          this.props.loadMantenimiento();
          this.props.fetchDiasEntrega(sucursalDespacho, sucursalEntrega, cantidadDias)
            .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
              cantidad: data.planificacionDiasEntrega.length,
              pagina: 1 }));
        } else {
          this.showAlert('alertErrorOpen');
        }
        this.resetForm();
      });
  }

  editRegistro = (registro) => {
    
    editDiasTraslado(this.state, registro)
      .then((response) => {
        const { sucursalDespacho, sucursalEntrega, cantidadDias } = this.state;
        if (response.data.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');
          this.props.loadMantenimiento();
          this.props.fetchDiasEntrega(sucursalDespacho, sucursalEntrega, cantidadDias)
            .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
              cantidad: data.planificacionDiasEntrega.length,
              pagina: 1 }));
        } else {
          this.showAlert('alertErrorOpen');
        }
        this.resetForm();
      });
  }

  closeAlertError = () => this.setState({ alertErrorOpen: false });
  closeAlertSuccess = () => this.setState({ alertSuccessOpen: false });

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  closeModal = () => this.setState({ modalOpen: '' });
  openModal = modal => this.setState({ modalOpen: modal });
  openModalWithValues = (modal, mantenimiento) => {

    console.log('mantenimiento',mantenimiento);
    
    this.setState({
      modalOpen: modal,
      disabledSelects: true,
      modalTitle: 'Editar registro',
      sucDespacho: mantenimiento.codSucuOrig || '',
      sucEntrega: mantenimiento.codSucuDest || '',
      canDias: mantenimiento.canDias || '',
      indInactivo: mantenimiento.indInactivo === 'NO',
      registroSelected: mantenimiento.codConfPlanDias,
      familia:mantenimiento.codFamilia,
    });
  }

  backPag = () => {
    if (this.state.pagina === 1) return;
    this.setState(
      { pagina: this.state.pagina - 1 },
      () => {
        const { sucursalDespacho, sucursalEntrega, cantidadDias, pagina } = this.state;
        this.props.loadMantenimiento();
        this.props.fetchDiasEntrega(sucursalDespacho, sucursalEntrega, cantidadDias, pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.planificacionDiasEntrega.length }));
      }
    );
  }

  nextPag = () => {
    if (this.state.pagina * 10 > this.state.totalRegistros) return;
    this.setState(
      { pagina: this.state.pagina + 1 },
      () => {
        const { sucursalDespacho, sucursalEntrega, cantidadDias, pagina } = this.state;
        this.props.loadMantenimiento();
        this.props.fetchDiasEntrega(sucursalDespacho, sucursalEntrega, cantidadDias, pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.planificacionDiasEntrega.length }));
      }
    );
  }

  filter = () => {
    const { sucursalDespacho, sucursalEntrega, cantidadDias, pagina } = this.state;
    this.props.loadMantenimiento();
    this.props.fetchDiasEntrega(sucursalDespacho, sucursalEntrega, cantidadDias, pagina)
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.planificacionDiasEntrega.length,
        pagina: 1 }));
  }

  reset = () => {
    this.setState({
      sucursalEntrega: '',
      sucursalDespacho: '',
      cantidadDias: '',
      familia: '',

    });
    this.props.loadMantenimiento();
    this.props.fetchDiasEntrega()
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.planificacionDiasEntrega.length,
        pagina: 1 }));
  }

  resetForm = () => {
    this.setState({
      sucDespacho: '',
      sucEntrega: '',
      canDias: '',
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      modalTitle: 'Crear registro',
      modalOpen: '',
      familia: '',

    });
  }

  filterFamilia = (item) =>{
    if(item!== null){
      return this.props.familias.filter((items)=> +items.codFamiliaVeh === +item )[0].desFamiliaVeh;
    }
    return "";
  }

  render() {
    const {familias, mantenimientoEntrega, sucursales } = this.props;

    return (
      <div>
        <PageHeader title='Mantenimiento de dias para traslado de vehiculos' openModal={this.openModal} buttonName='Nuevo registro' modalName='mantenimiento' />
        <Filtros
          sucursales={sucursales ? sucursales.sucursalResponse : []}
          sucursalEntrega={this.state.sucursalEntrega}
          sucursalDespacho={this.state.sucursalDespacho}
          cantidadDias={this.state.cantidadDias}
          filter={this.filter}
          unidadMax={this.state.unidadMax}
          onChangeValue={this.onChangeValue}
          onChangeAndFilter={this.onChangeAndFilter}
          reset={this.reset}
        />
        <Paginacion
          paginas={this.state.totalRegistros}
          pagina={this.state.pagina}
          cantidad={this.state.cantidad}
          backPag={this.backPag}
          nextPag={this.nextPag}
        />
        <div className='wrapper'>
          <div className='tableWrapper'>
            <table className='table table-hover' style={{ marginBottom: '20px' }} >
              <thead className='table-head'>
                <tr>
                  <th>ID</th>
                  <th>Sucursal de despacho</th>
                  <th>Sucursal de entrega</th>
                  <th>Familia</th>
                  <th>Cantidad de días</th>
                  <th>Indicador de inactividad</th>
                  <th />
                </tr>
              </thead>
              {
                mantenimientoEntrega ?
                  <TablaMantenimiento
                    lugares={mantenimientoEntrega.planificacionDiasEntrega}
                    openModal={this.openModalWithValues}
                    familias={familias}
                    filterFamilia={this.filterFamilia}

                  /> :
                  <tbody>
                    <tr>
                      <td colSpan={6}><FadeLoader color={'#F8A14A'} loading /></td>
                    </tr>
                  </tbody>
              }
            </table>
          </div>
        </div>
        <Formulario
          isOpen={this.state.modalOpen === 'mantenimiento'}
          title={this.state.modalTitle}
          closeModal={this.resetForm}
          onChangeValue={this.onChangeValue}
          create={this.createRegistro}
          edit={this.editRegistro}
          sucursales={sucursales ? sucursales.sucursalResponse : []}
          disabled={this.state.disabledSelects}
          sucDespacho={this.state.sucDespacho}
          sucEntrega={this.state.sucEntrega}
          canDias={this.state.canDias}
          indInactivo={this.state.indInactivo}
          registroSelected={this.state.registroSelected}
          onCheck={this.onCheck}
          familias={this.props.familias}
          familia = {this.state.familia}
        />
        {
          this.state.alertErrorOpen &&
            <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
              <p>Hubo un error al guardar el registro</p>
            </Alert>
        }
        {
          this.state.alertSuccessOpen &&
            <Alert type='alert-success' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess}>
              <p>Se guardó correctamente el registro</p>
            </Alert>
        }
        {
          (mantenimientoEntrega && mantenimientoEntrega.error) &&
            <Alert type='alert-danger' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar registros</p>
            </Alert>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mantenimientoEntrega: state.mantenimientoEntrega,
    sucursales: state.sucursales,
    familias: state.familias,

  };
}
MantDiasTraslado.defaultProps = {
  familias: [],
  filiales: [],
};
export default connect(
  mapStateToProps,
  { loadMantenimiento,fetchFamilia, fetchDiasEntrega, fetchSucursales }
)(MantDiasTraslado);



// WEBPACK FOOTER //
// ./src/pages/MantDiasTraslado/MantDiasTraslado.js